import axios from "axios";
// import { useDispatch } from "react-redux";
export const fetchProductsStart = () => ({
  type: "FETCH_PRODUCTS_START",
});

export const fetchProductsSuccess = (products) => ({
  type: "FETCH_PRODUCTS_SUCCESS",
  payload: products,
});

export const fetchProductsFailure = (error) => ({
  type: "FETCH_PRODUCTS_FAILURE",
  payload: error,
});

export const fetchProductsStartAsync = () => {
  return async (dispatch) => {
    dispatch(fetchProductsStart());
    try{
        let products = await axios.get(process.env.REACT_APP_SERVER_URL+ "/api/products");
    dispatch(fetchProductsSuccess(products.data));
    }
    catch(e){
        console.log(e);
    }
  };
};
